import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {AccountEntity} from './account.entity';
import {PersonEntity} from './person.entity';
import {SystemVersionEntity} from './system.version.entity';

@EntityTable('system', '0f703271-e521-4d4e-9e73-3d6d0b7fd953')
export class SystemEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.STRING)
    public title: string;

    @Column(FieldTypeKind.ANY)
    public theme: any;

    @JoinColumn(FieldTypeKind.GUID, AccountEntity, false, false, FieldRelationKind.BELONGS_TO, 'account')
    public accountId: string;

    @JoinColumn(FieldTypeKind.GUID, PersonEntity, true, false, FieldRelationKind.BELONGS_TO, 'person')
    public personId: string;

    @Column(FieldTypeKind.GUID)
    public ownerId: string;

    @Transient()
    public domains: any[];

    @Transient()
    public domain: any;

    @Transient()
    public systemVersion: SystemVersionEntity;
}
